module.exports = __webpack_public_path__ + "img/role.7c725cd9.svg";